import './assets/css/main.css'; 
import './App.css';
import Header from './components/Header.tsx';
import Navigation from './components/Navigation.tsx';
import Main from './components/Main.tsx';
import Footer from './components/Footer.tsx';

function App() {
  return (
    <div id="wrapper">
      <Header />
      <Navigation />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
